"use client";

import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { PlanCtaLink } from "@/components/pricing/plan-cta-link";

/**
 * Client component wrappers for CTA buttons on the landing page.
 *
 * These are necessary because Button with asChild + Next.js Link doesn't
 * render correctly in Server Components during production builds.
 * The Radix Slot component's element cloning fails silently in RSC.
 *
 * The #pricing anchors use a plain <a> on purpose: next/link turns a repeat
 * click on the same hash into a no-op navigation, so the page stops scrolling
 * after the first click. A native anchor re-scrolls every time.
 */

export function HeroCTAButton({ trialDays = 0 }: { trialDays?: number }) {
  return (
    <Button
      asChild
      size="lg"
      className="cta-forge group h-14 px-8 text-base font-bold"
    >
      <a href="#pricing">
        {trialDays > 0 ? "Prueba Avante Fit Gratis" : "Comenzar Ahora"}
        <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
      </a>
    </Button>
  );
}

export function TransformationCTAButton({
  trialDays = 0,
}: {
  trialDays?: number;
}) {
  return (
    <Button
      asChild
      size="lg"
      className="cta-forge group h-14 px-8 text-base font-bold"
    >
      <a href="#pricing">
        {trialDays > 0 ? "Prueba Avante Fit Gratis" : "Comenzar Ahora"}
        <ArrowRight className="ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
      </a>
    </Button>
  );
}

export function MonthlyPlanButton({ trialDays = 0 }: { trialDays?: number }) {
  return (
    <Button
      asChild
      size="lg"
      variant="outline"
      className="w-full border-white/20 bg-transparent text-white hover:bg-white/10 hover:text-white"
    >
      <PlanCtaLink plan="monthly">
        {trialDays > 0
          ? `Comenzar ${trialDays} Días Gratis`
          : "Comenzar Plan Mensual"}
      </PlanCtaLink>
    </Button>
  );
}

export function AnnualPlanButton({ trialDays = 0 }: { trialDays?: number }) {
  return (
    <Button asChild size="lg" className="cta-forge w-full">
      <PlanCtaLink plan="annual">
        {trialDays > 0
          ? `Comenzar ${trialDays} Días Gratis`
          : "Comenzar Plan Anual"}
      </PlanCtaLink>
    </Button>
  );
}

export function FinalCTAButton({ trialDays = 0 }: { trialDays?: number }) {
  return (
    <Button
      asChild
      size="lg"
      className="cta-forge group h-16 px-12 text-lg font-bold"
    >
      <a href="#pricing">
        {trialDays > 0 ? "Probar Avante Fit Gratis" : "Comenzar Ahora"}
        <ArrowRight className="ml-2 h-6 w-6 transition-transform group-hover:translate-x-1" />
      </a>
    </Button>
  );
}
